import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { RecoilRoot } from "recoil";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import WalletProvider from "./provider/WalletProvider";
import { Body } from "./Body";
import { OpenAPI } from "./openapi";
import "!style-loader!css-loader!react-toastify/dist/ReactToastify.css"; // eslint-disable-line

import "./index.scss";
import "react-responsive-pagination/themes/classic.css";

function App() {
  OpenAPI.BASE = process.env.REACT_APP_BACKEND_ENDPOINT as string;

  return (
    <>
      <RecoilRoot>
        <BrowserRouter>
          <WalletProvider>
            <Body />
            <ToastContainer />
          </WalletProvider>
        </BrowserRouter>
      </RecoilRoot>
    </>
  );
}

export default App;
